import { render, staticRenderFns } from "./3f.vue?vue&type=template&id=36d560d0&"
import script from "./3f.vue?vue&type=script&lang=js&"
export * from "./3f.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports